import styled from "@emotion/styled";
import { FormHelperText, Select, SelectProps } from "@mui/material";

import { SystemsOfMeasurement } from "fond/types";
import { Currency } from "fond/types/currency";

export const ShortSelect = styled((props: SelectProps<`${SystemsOfMeasurement}`>) => <Select {...props} />)(() => ({
  width: 160,
  paddingLeft: 0.5,
}));

export const CurrencySelect = styled((props: SelectProps<Currency>) => <Select {...props} />)(() => ({
  width: 160,
  paddingLeft: 0.5,
}));

export const SelectHelperText = styled(FormHelperText)(() => ({
  marginLeft: 0,
}));
